<template>
    <b-container fluid class="h-100 pl-0 m-0 overflow-hidden">
        <b-row class="h-100">
            <b-col cols="4" class="h-100">
                <!-- Patrimoine à saisir  -->
                <b-card class="border-bottom pt-0 h-100 d-flex flex-column" bg-variant="white" header-tag="header" header-class="bg-white border-bottom" 
                    body-class="d-flex flex-column p-3 flex-grow-1 overflow-hidden">
                    <template #header>
                        <b-form-group :label="(SelectorTitle) ? SelectorTitle : $t('AvailableAssets')" label-class="font-weight-bold text-dark p-0" label-size="lg" class="m-0"/>
                    </template>
                    <!-- Zone de saisie avec outils de recherches -->
                    <div class="mb-2 flex-shrink-0">
                        {{ (SelectorSubTitle) ? SelectorSubTitle : $t('SelectNodeForUser')  }}
                    </div>
                    <!-- Arborescence d'objet -->
                    <div class="flex-grow-1 d-flex flex-column overflow-hidden" style="min-height: 0;">
                        <HeritageTree @contextmenu.stop.prevent :Variant="Variant" :IsDraggable="true" :FilterTreeStore="FilterTreeStore" :SelectMode="selectMode"
                            :disabled="!$store.getters['CheckAction']('Read', undefined, Action)"
                            :ShowToolbar="true" :ShowSearchButton="true"
                            class="pt-0 flex-grow-1" v-on="$listeners" />
                    </div>
                </b-card>
            </b-col>
            <b-col cols="8" class="pr-0 h-100">
                <!-- Patrimoine associés et affichage des filtres -->
                <b-card class="border-bottom pt-0 h-100 d-flex flex-column" bg-variant="white" header-class="bg-white border-bottom" body-class="d-flex flex-column h-100 overflow-hidden" footer-class="bg-white border-top">
                    <template #header>
                        <b-form-group :label="(PinsDisplayerTitle) ? PinsDisplayerTitle : $t('ConnectedAssets')" label-class="font-weight-bold text-dark p-0" label-size="lg" class="m-0" />
                    </template>

                    <!-- Listes des pins -->
                    <div class="flex-grow-1 overflow-auto" style="min-height: 0;">
                        <PinsCards :Variant="Variant" :FilterTreeStore="FilterTreeStore" :PropertiesFilterPinTypes="this.propertiesFilterPinTypes" />
                    </div>

                    <!-- Pied de bloc patrimoine associé -->
                    <template #footer>
                        <b-row>
                            <!-- <b-col cols="auto" class="mr-auto px-0">{{ $tc('CountSelectedNode', pinsSelected.length, { count: pinsSelected.length }) }}</b-col> -->
                            <!-- <b-col v-if="IsModified" cols="auto" class="px-0">{{ $t('WarnUpdatedFields') }}</b-col> -->
                            <!-- <b-col v-if="pinsSelected.length > pinsPerPage " cols="auto" class="mr-auto px-0" >
                                <b-pagination 
                                    v-model="indexCurrentPage"
                                    :total-rows="pinsSelected.length"
                                    :per-page="pinsPerPage"
                                    aria-controls="pinsList"
                                    class="m-0">
                            </b-pagination></b-col> -->
                        </b-row>
                    </template>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script lang="ts">
/** Vue.js */
import Component from 'vue-class-component';
import { Vue, InjectReactive, Prop, PropSync } from 'vue-property-decorator';

/** Localisation avec i18n */
import locales from './locales/HeritageNodeSelector.json'

/** Types personnalisés */
import SelectModeEnum from '@/enums/SelectModeEnum';
import PinTypeEnum from '@/enums/PinTypeEnum';
import Pin from '@/types/FilterTree/Pin';

/** Composant personnalisés */
import HeritageTree from '@/components/commons/HeritageTree.vue';
import PropertiesFilter from '@/components/commons/Pins/PropertiesFilter.vue';
import Pins from '@/components/commons/Pins.vue';
import PinsCards from '@/components/commons/PinsCards.vue';

/** Sélecteur de noeud d'arborescence patrimoniale permettant d’assigner des droits d’accès spécifiques. */
@Component({
    components: {
        HeritageTree,
        Pins,
        PinsCards,
        PropertiesFilter
	},
    i18n: { messages : locales}
})
export default class HeritageNodeSelector extends Vue {
    /** Nécessaire pour pouvoir utiliser l'enum PinTypeEnum dans la section template */
    private pinTypeEnum = PinTypeEnum;
    private selectModeEnum = SelectModeEnum;

    /** Titre du selecteur de noeud */
    @Prop({default: ""})
    public SelectorTitle!: string;
    
    /** Sous titre du selecteur de noeud  */
    @Prop({default: ""})
    public SelectorSubTitle!: string;

    /** Titre de l'afficheur de "pins" selectionné */
    @Prop({default: ""})
    public PinsDisplayerTitle!: string;

    /** Couleur de variant à appliquer sur le composant */
    @InjectReactive()
    private Variant!: string;
    /** Store de référence pour ce HeritageTree */
    @Prop({ default: "" })
    public FilterTreeStore!: string;

    /** Indique si les champs sont considéré comme modifié. */
    @Prop({default: false})
    public IsModified!: Boolean;

    /** Droit disponible pour l'utilisateur en cours */
    @InjectReactive()
    public Action!: string;

    /** Mode de sélection de l'arborescence */
    protected selectMode: SelectModeEnum = SelectModeEnum.MultiSimple;

    /** Nœud sélectionné pour l'utilisateur */
    @PropSync('PinsSelected', { default: () => []})
    private pinsSelected!: Pin[]
    
    /** Page courante de pagination */
    private indexCurrentPage: number = 1;
    
    /** Nombre de pins affiché par page*/
    private pinsPerPage: number = 9;

    /** Liste des types de Pin pour les filtres par propriétés */
    private propertiesFilterPinTypes: PinTypeEnum[] = [ PinTypeEnum.None, PinTypeEnum.Tree];

    /**
     * Pointeur vers fonction pour désactiver watchers
     * @see https://vuejs.org/guide/essentials/watchers#stopping-a-watcher
     */
    private unwatchGetPins = undefined;

    /** Indique si l'aborescence est ouverte sur les noeuds selectionné */
    private IsExpandSelected: boolean = false;

    /** Replie les noeuds de l'arborescence sans affecté les autres paramètres */
    private async collapseExpandAll() {

        if(this.IsExpandSelected){
            await this.$store.dispatch(this.FilterTreeStore + '/CloseAllNode');
            this.IsExpandSelected = false;
        }
        else{
            this.pinsSelected.forEach(async (node) =>{
                await this.$store.dispatch(this.FilterTreeStore + '/OpenNode', { node: node, scrollIntoView: false })
            });
            this.IsExpandSelected = true;
        }
    }

    /** Charge les pins du FilterTree et initialise le watcher */
    async mounted(){
        await this.$store.dispatch("ShowLoadingMask", this.$t('LoadingUserInformation'));   

        /** Watcher sur les pin du FilterTree */
        this.unwatchGetPins = this.$store.watch((state, getters) => getters[this.FilterTreeStore + '/GetPins'], val => {
            this.pinsSelected = val;
        }, { immediate: true });

        await this.$store.dispatch("HideLoadingMask", {}); 
        /** Déplie l'arborescence sur la selection */
        this.collapseExpandAll();
        /** Signal la fin du chargement du composant */
        this.$emit('loaded');
    }

    /** Netoyage des watchers */
    beforeDestroy() {
        // Libération du watcher
        if (this.unwatchGetPins)
            this.unwatchGetPins();
    }
}
</script>

<style scoped>
/** Pour que la page active prenne en compte la couleur de Variant */
:deep(.page-item.active .page-link) {
    background-color: var(--Variant) !important;
}

:deep(.page-link:hover) {
    background-color: var(--VariantLight) !important;
}
</style>